var map = {
	"./square/ac.svg": 1753,
	"./square/ad.svg": 1754,
	"./square/ae.svg": 1755,
	"./square/af.svg": 1756,
	"./square/ag.svg": 1757,
	"./square/ai.svg": 1758,
	"./square/al.svg": 1759,
	"./square/am.svg": 1760,
	"./square/ao.svg": 1761,
	"./square/aq.svg": 1762,
	"./square/ar.svg": 1763,
	"./square/as.svg": 1764,
	"./square/at.svg": 1765,
	"./square/au.svg": 1766,
	"./square/aw.svg": 1767,
	"./square/ax.svg": 1768,
	"./square/az.svg": 1769,
	"./square/ba.svg": 1770,
	"./square/bb.svg": 1771,
	"./square/bd.svg": 1772,
	"./square/be.svg": 1773,
	"./square/bf.svg": 1774,
	"./square/bg.svg": 1775,
	"./square/bh.svg": 1776,
	"./square/bi.svg": 1777,
	"./square/bj.svg": 1778,
	"./square/bl.svg": 1779,
	"./square/bm.svg": 1780,
	"./square/bn.svg": 1781,
	"./square/bo.svg": 1782,
	"./square/bq.svg": 1783,
	"./square/br.svg": 1784,
	"./square/bs.svg": 1785,
	"./square/bt.svg": 1786,
	"./square/bv.svg": 1787,
	"./square/bw.svg": 1788,
	"./square/by.svg": 1789,
	"./square/bz.svg": 1790,
	"./square/ca.svg": 1791,
	"./square/cc.svg": 1792,
	"./square/cd.svg": 1793,
	"./square/cefta.svg": 1794,
	"./square/cf.svg": 1795,
	"./square/cg.svg": 1796,
	"./square/ch.svg": 1797,
	"./square/ci.svg": 1798,
	"./square/ck.svg": 1799,
	"./square/cl.svg": 1800,
	"./square/cm.svg": 1801,
	"./square/cn.svg": 1802,
	"./square/co.svg": 1803,
	"./square/cp.svg": 1804,
	"./square/cr.svg": 1805,
	"./square/cu.svg": 1806,
	"./square/cv.svg": 1807,
	"./square/cw.svg": 1808,
	"./square/cx.svg": 1809,
	"./square/cy.svg": 1810,
	"./square/cz.svg": 1811,
	"./square/de.svg": 1812,
	"./square/dg.svg": 1813,
	"./square/dj.svg": 1814,
	"./square/dk.svg": 1815,
	"./square/dm.svg": 1816,
	"./square/do.svg": 1817,
	"./square/dz.svg": 1818,
	"./square/ea.svg": 1819,
	"./square/ec.svg": 1820,
	"./square/ee.svg": 1821,
	"./square/eg.svg": 1822,
	"./square/eh.svg": 1823,
	"./square/er.svg": 1824,
	"./square/es-ct.svg": 1825,
	"./square/es-ga.svg": 1826,
	"./square/es.svg": 1827,
	"./square/et.svg": 1828,
	"./square/eu.svg": 1829,
	"./square/fi.svg": 1830,
	"./square/fj.svg": 1831,
	"./square/fk.svg": 1832,
	"./square/fm.svg": 1833,
	"./square/fo.svg": 1834,
	"./square/fr.svg": 1835,
	"./square/ga.svg": 1836,
	"./square/gb-eng.svg": 1837,
	"./square/gb-nir.svg": 1838,
	"./square/gb-sct.svg": 1839,
	"./square/gb-wls.svg": 1840,
	"./square/gb.svg": 1841,
	"./square/gd.svg": 1842,
	"./square/ge.svg": 1843,
	"./square/gf.svg": 1844,
	"./square/gg.svg": 1845,
	"./square/gh.svg": 1846,
	"./square/gi.svg": 1847,
	"./square/gl.svg": 1848,
	"./square/gm.svg": 1849,
	"./square/gn.svg": 1850,
	"./square/gp.svg": 1851,
	"./square/gq.svg": 1852,
	"./square/gr.svg": 1853,
	"./square/gs.svg": 1854,
	"./square/gt.svg": 1855,
	"./square/gu.svg": 1856,
	"./square/gw.svg": 1857,
	"./square/gy.svg": 1858,
	"./square/hk.svg": 1859,
	"./square/hm.svg": 1860,
	"./square/hn.svg": 1861,
	"./square/hr.svg": 1862,
	"./square/ht.svg": 1863,
	"./square/hu.svg": 1864,
	"./square/ic.svg": 1865,
	"./square/id.svg": 1866,
	"./square/ie.svg": 1867,
	"./square/il.svg": 1868,
	"./square/im.svg": 1869,
	"./square/in.svg": 1870,
	"./square/io.svg": 1871,
	"./square/iq.svg": 1872,
	"./square/ir.svg": 1873,
	"./square/is.svg": 1874,
	"./square/it.svg": 1875,
	"./square/je.svg": 1876,
	"./square/jm.svg": 1877,
	"./square/jo.svg": 1878,
	"./square/jp.svg": 1879,
	"./square/ke.svg": 1880,
	"./square/kg.svg": 1881,
	"./square/kh.svg": 1882,
	"./square/ki.svg": 1883,
	"./square/km.svg": 1884,
	"./square/kn.svg": 1885,
	"./square/kp.svg": 1886,
	"./square/kr.svg": 1887,
	"./square/kw.svg": 1888,
	"./square/ky.svg": 1889,
	"./square/kz.svg": 1890,
	"./square/la.svg": 1891,
	"./square/lb.svg": 1892,
	"./square/lc.svg": 1893,
	"./square/li.svg": 1894,
	"./square/lk.svg": 1895,
	"./square/lr.svg": 1896,
	"./square/ls.svg": 1897,
	"./square/lt.svg": 1898,
	"./square/lu.svg": 1899,
	"./square/lv.svg": 1900,
	"./square/ly.svg": 1901,
	"./square/ma.svg": 1902,
	"./square/mc.svg": 1903,
	"./square/md.svg": 1904,
	"./square/me.svg": 1905,
	"./square/mf.svg": 1906,
	"./square/mg.svg": 1907,
	"./square/mh.svg": 1908,
	"./square/mk.svg": 1909,
	"./square/ml.svg": 1910,
	"./square/mm.svg": 1911,
	"./square/mn.svg": 1912,
	"./square/mo.svg": 1913,
	"./square/mp.svg": 1914,
	"./square/mq.svg": 1915,
	"./square/mr.svg": 1916,
	"./square/ms.svg": 1917,
	"./square/mt.svg": 1918,
	"./square/mu.svg": 1919,
	"./square/mv.svg": 1920,
	"./square/mw.svg": 1921,
	"./square/mx.svg": 1922,
	"./square/my.svg": 1923,
	"./square/mz.svg": 1924,
	"./square/na.svg": 1925,
	"./square/nc.svg": 1926,
	"./square/ne.svg": 1927,
	"./square/nf.svg": 1928,
	"./square/ng.svg": 1929,
	"./square/ni.svg": 1930,
	"./square/nl.svg": 1931,
	"./square/no.svg": 1932,
	"./square/np.svg": 1933,
	"./square/nr.svg": 1934,
	"./square/nu.svg": 1935,
	"./square/nz.svg": 1936,
	"./square/om.svg": 1937,
	"./square/pa.svg": 1938,
	"./square/pe.svg": 1939,
	"./square/pf.svg": 1940,
	"./square/pg.svg": 1941,
	"./square/ph.svg": 1942,
	"./square/pk.svg": 1943,
	"./square/pl.svg": 1944,
	"./square/pm.svg": 1945,
	"./square/pn.svg": 1946,
	"./square/pr.svg": 1947,
	"./square/ps.svg": 1948,
	"./square/pt.svg": 1949,
	"./square/pw.svg": 1950,
	"./square/py.svg": 1951,
	"./square/qa.svg": 1952,
	"./square/re.svg": 1953,
	"./square/ro.svg": 1954,
	"./square/rs.svg": 1955,
	"./square/ru.svg": 1956,
	"./square/rw.svg": 1957,
	"./square/sa.svg": 1958,
	"./square/sb.svg": 1959,
	"./square/sc.svg": 1960,
	"./square/sd.svg": 1961,
	"./square/se.svg": 1962,
	"./square/sg.svg": 1963,
	"./square/sh.svg": 1964,
	"./square/si.svg": 1965,
	"./square/sj.svg": 1966,
	"./square/sk.svg": 1967,
	"./square/sl.svg": 1968,
	"./square/sm.svg": 1969,
	"./square/sn.svg": 1970,
	"./square/so.svg": 1971,
	"./square/sr.svg": 1972,
	"./square/ss.svg": 1973,
	"./square/st.svg": 1974,
	"./square/sv.svg": 1975,
	"./square/sx.svg": 1976,
	"./square/sy.svg": 1977,
	"./square/sz.svg": 1978,
	"./square/ta.svg": 1979,
	"./square/tc.svg": 1980,
	"./square/td.svg": 1981,
	"./square/tf.svg": 1982,
	"./square/tg.svg": 1983,
	"./square/th.svg": 1984,
	"./square/tj.svg": 1985,
	"./square/tk.svg": 1986,
	"./square/tl.svg": 1987,
	"./square/tm.svg": 1988,
	"./square/tn.svg": 1989,
	"./square/to.svg": 1990,
	"./square/tr.svg": 1991,
	"./square/tt.svg": 1992,
	"./square/tv.svg": 1993,
	"./square/tw.svg": 1994,
	"./square/tz.svg": 1995,
	"./square/ua.svg": 1996,
	"./square/ug.svg": 1997,
	"./square/um.svg": 1998,
	"./square/un.svg": 1999,
	"./square/us.svg": 2000,
	"./square/uy.svg": 2001,
	"./square/uz.svg": 2002,
	"./square/va.svg": 2003,
	"./square/vc.svg": 2004,
	"./square/ve.svg": 2005,
	"./square/vg.svg": 2006,
	"./square/vi.svg": 2007,
	"./square/vn.svg": 2008,
	"./square/vu.svg": 2009,
	"./square/wf.svg": 2010,
	"./square/ws.svg": 2011,
	"./square/xk.svg": 2012,
	"./square/xx.svg": 2013,
	"./square/ye.svg": 2014,
	"./square/yt.svg": 2015,
	"./square/za.svg": 2016,
	"./square/zm.svg": 2017,
	"./square/zw.svg": 2018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1752;